export default function helpers({ history, cookies }) {
  return {
    history,
    cookies,
  };
}
